<script setup lang="ts">

</script>

<template>
  <div
      class="loading-bar"
  />
</template>
<style lang="scss" scoped>
@keyframes pulse {
  0%, 100% {
    background-color: #f56a3f;
  }
  50% {
    background-color: #9e42b0;
  }
}

.loading-bar {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  animation: pulse 1s infinite;
}
</style>
